import { collection, doc, getDoc } from "firebase/firestore";

export const ANONYMOUS_COMMENT_AUTHOR = "Anonymous";
export const DELETED_COMMENT_AUTHOR = "[deleted]";

export const normalizeHideNameSetting = (data) => {
  return Boolean(data?.commentSettings?.hideName);
};

const isCommentDeleted = (comment) => {
  return (
    comment?.isDeleted ||
    comment?.author === DELETED_COMMENT_AUTHOR
  );
};

export const loadCurrentUserCommentHideName = async (db, uid) => {
  if (!uid) {
    return false;
  }

  try {
    const userRef = doc(collection(db, "users"), uid);
    const userSnap = await getDoc(userRef);

    if (!userSnap.exists()) {
      return false;
    }

    return normalizeHideNameSetting(userSnap.data());
  } catch (error) {
    console.error("Failed to load current user comment settings:", error);
    return null;
  }
};

export const useCommentPrivacy = () => {
  const isCommentAuthorNameHidden = (comment) => {
    if (isCommentDeleted(comment)) {
      return false;
    }

    return Boolean(comment?.hideNameFromOthers);
  };

  const getCommentDisplayName = (comment, isAdmin = false) => {
    if (isCommentDeleted(comment)) {
      return DELETED_COMMENT_AUTHOR;
    }

    if (isCommentAuthorNameHidden(comment) && !isAdmin) {
      return ANONYMOUS_COMMENT_AUTHOR;
    }

    const author =
      typeof comment?.author === "string" ? comment.author.trim() : "";

    return author || "Unknown";
  };

  const getCommentDisplayShortName = (comment, isAdmin = false) => {
    const displayName = getCommentDisplayName(comment, isAdmin);
    if (
      !displayName ||
      displayName === DELETED_COMMENT_AUTHOR ||
      displayName === ANONYMOUS_COMMENT_AUTHOR
    ) {
      return displayName;
    }

    return displayName.split(" ")[0];
  };

  return {
    getCommentDisplayName,
    getCommentDisplayShortName,
    isCommentAuthorNameHidden,
  };
};
